module.exports = __webpack_public_path__ + "static/img4f-78cd2692accfc93a0c5e5b7b61fa2ccc.jpg";